import { t } from '@lingui/macro'
import dayjs from 'dayjs'

export function auditActionLabel(action: string): string {
  switch (action) {
    case 'session_created':
      return t`Session created`
    case 'session_closed':
      return t`Session closed`
    case 'session_corrected':
      return t`Session corrected`
    case 'session_created_admin':
      return t`Session created by admin`
    case 'consent_enabled':
      return t`Consent enabled`
    case 'consent_disabled':
      return t`Consent disabled`
    default:
      return action
  }
}

export function auditRoleLabel(role: string): string {
  switch (role) {
    case 'doctor':
      return t`Staff`
    case 'admin_facility':
      return t`Facility admin`
    case 'admin_network':
      return t`Network admin`
    default:
      return role
  }
}

export function auditReasonLabel(reason: string | null): string {
  if (!reason) return ''
  switch (reason) {
    case 'forgotten_clock':
      return t`Forgotten clock-in/out`
    case 'technical_issue':
      return t`Technical issue`
    case 'recovered_leave':
      return t`Recovered leave`
    case 'data_entry_error':
      return t`Data entry error`
    default:
      return reason
  }
}

export function formatAuditValue(field: string, value: unknown): string {
  if (value === null || value === undefined) return '—'
  if (field === 'startTime' || field === 'endTime') {
    return dayjs(value as string).format('DD/MM/YYYY HH:mm')
  }
  return String(value)
}
